import actionTypes from '../actions/actionTypes'
import viewTypes from 'helpers/enums/viewTypes'
import platformTypes from 'helpers/enums/platformTypes'
import sessionTypes from 'helpers/enums/sessionTypes'
import jwtDecode from 'jwt-decode'

function handleStandalonePreviewCurrentView(state, action) {
	const decodedJwt = jwtDecode(action.jwt)
	const sessionType = parseInt(decodedJwt.extra.session_type)
	if (sessionType === sessionTypes.EMBED) {
		return {
			...state,
			currentView: viewTypes.LIBRARY,
		}
	}
	return state
}

const defaultState = {
	width: 0,
	height: 0,
	platform: 'web',
	currentView: '',
	isInIframe: false,
	isActivityOnboardingSession: false,
	storeRouteOrigin: false, // TODO: Delete when delete the FF STORE_NEW_ROUTES
}

const uiReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.UI_WINDOW_RESIZE: {
			return {
				...state,
				width: action.width,
				height: action.height,
			}
		}
		case actionTypes.INTERACTIVE_VIDEO_STANDALONE_INITIALIZE:
			return handleStandalonePreviewCurrentView(state, action)
		case actionTypes.MY_LIBRARY_PREVIEW_INITIALIZE:
		case actionTypes.MY_LIBRARY_INITIALIZE: {
			return {
				...state,
				currentView: viewTypes.LIBRARY,
			}
		}
		// TODO: Delete when delete the FF STORE_NEW_ROUTES
		case actionTypes.STORE_BASE_ROUTE_INITIALIZE:
			return {
				...state,
				storeRouteOrigin: action.originRouteType,
			}
		case actionTypes.STORE_LANDING_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.STORE_LANDING,
			}
		case actionTypes.STORE_SEARCH_ROUTE_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.STORE_SEARCH,
			}
		case actionTypes.STORE_FOLDER_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.STORE_FOLDER,
			}
		case actionTypes.STORE_PREVIEW_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.STORE_PREVIEW,
			}
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_EDIT:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_BASE:
			return {
				...state,
				currentView: viewTypes.INTERACTIVE_VIDEO_CREATE,
			}
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_SELECT_ROUTE:
			return {
				...state,
				currentView: viewTypes.INTERACTIVE_VIDEO_SELECT,
			}
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_SCREENSHOT_ROUTE:
			return {
				...state,
				currentView: viewTypes.INTERACTIVE_VIDEO_SCREENSHOT,
			}
		case actionTypes.APP_INITIALIZE: {
			return {
				...state,
				width: action.width,
				height: action.height,
				platform: action.platform,
				isInIframe: action.isInIframe,
			}
		}
		case actionTypes.PRIVATE_LIBRARY_SETTINGS_FETCHED:
			return {
				...state,
				currentView: action.settings.entity_type === 'school' ? 'school-library' : action.settings.entity_type === 'district' ? 'district-library' : viewTypes.SUPPLEMENTAL_CURRICULUM,
			}
		case actionTypes.PRIVATE_LIBRARY_FINALIZE:
		case actionTypes.MY_ACCOUNT_FINALIZE_BASE:
		case actionTypes.QUIZ_FINALIZE:
		case actionTypes.MATCHING_PAIRS_FINALIZE_ROUTE:
		case actionTypes.DRAW_IT_FINALIZE_CREATION_TOOL:
		case actionTypes.OEQ_FINALIZE_CREATION_TOOL:
		case actionTypes.GAME_FINALIZE_CREATION_TOOL:
		case actionTypes.POLL_FINALIZE_CREATION_TOOL:
		case actionTypes.DESMOS_FINALIZE_CREATION_TOOL:
		case actionTypes.DESMOS_FINALIZE_CREATION_TOOL_STANDALONE:
		case actionTypes.FLOCABULARY_FINALIZE_CREATION_TOOL:
		case actionTypes.STOREFRONT_FINALIZE:
		case actionTypes.STORE_LOCKED_CONTENT_FINALIZE_ROUTE:
		case actionTypes.QUICK_LAUNCH_OEQ_FINALIZE_CREATION_TOOL:
		case actionTypes.QUICK_LAUNCH_DRAW_IT_FINALIZE_CREATION_TOOL:
		case actionTypes.QUICK_LAUNCH_TIMER_FINALIZE:
		case actionTypes.MY_LIBRARY_PREVIEW_EXIT:
		case actionTypes.MY_LIBRARY_FINALIZE:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_FINALIZE:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_FINALIZE:
		case actionTypes.VIDEO_STANDALONE_OEQ_FINALIZE:
		case actionTypes.VIDEO_STANDALONE_MCQ_FINALIZE:
		case actionTypes.INTERACTIVE_VIDEO_SESSION_FINALIZE:
		case actionTypes.INTERACTIVE_VIDEO_PREVIEW_FINALIZE:
			return {
				...state,
				currentView: '',
			}
		case actionTypes.MAIN_TOPBAR_CONNECTOR_VIEW_UPDATE:
			return {
				...state,
				currentView: action.currentView,
			}
		case actionTypes.MY_ACCOUNT_INITIALIZE_BASE:
			return {
				...state,
				currentView: viewTypes.MY_ACCOUNT,
			}
		case actionTypes.STOREFRONT_OWNER_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.PUBLIC_LIBRARY_ADMIN,
			}
		case actionTypes.STOREFRONT_VISITOR_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.PUBLIC_LIBRARY,
			}
		case actionTypes.MY_ACTIVITIES_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.MY_ACTIVITIES,
			}
		case actionTypes.BINDERS_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.SUB_PLANS,
			}
		case actionTypes.MAIN_TOPBAR_CONNECTOR_INITIALIZE:
			return {
				...state,
				platform: platformTypes.EXTERNAL,
			}
		case actionTypes.MAIN_TOPBAR_CONNECTOR_FINALIZE:
			return {
				...state,
				currentView: '',
				platform: '',
			}
		case actionTypes.GOOGLE_SLIDES_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.GOOGLE_SLIDES_SIDEBAR,
			}
		case actionTypes.OEQ_INITIALIZE_STANDALONE:
		case actionTypes.QUIZ_INITIALIZE_STANDALONE:
		case actionTypes.POLL_INITIALIZE_STANDALONE:
			return {
				...state,
				currentView: viewTypes.STANDALONE_ACTIVITY,
			}
		case actionTypes.DRAW_IT_INITIALIZE_STANDALONE:
			return {
				...state,
				currentView: viewTypes.DRAW_IT_STANDALONE_CREATION,
			}
		case actionTypes.MATCHING_PAIRS_INITIALIZE_STANDALONE:
			return {
				...state,
				currentView: viewTypes.MATCHING_PAIRS_STANDALONE_CREATION,
			}
		case actionTypes.GAME_INITIALIZE_STANDALONE:
			return {
				...state,
				currentView: viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION,
			}
		case actionTypes.QUIZ_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.QUIZ_CREATION,
			}
		case actionTypes.POLL_INITIALIZE_CREATION_TOOL:
			return {
				...state,
				currentView: viewTypes.POLL_CREATION,
			}
		case actionTypes.OEQ_INITIALIZE_CREATION_TOOL:
			return {
				...state,
				currentView: viewTypes.OEQ_CREATION,
			}
		case actionTypes.DRAW_IT_INITIALIZE_CREATION_TOOL:
			return {
				...state,
				currentView: viewTypes.DRAW_IT_CREATION,
			}
		case actionTypes.MATCHING_PAIRS_CT_INITIALIZE_ROUTE:
			return {
				...state,
				currentView: viewTypes.MATCHING_PAIRS_CREATION,
			}
		case actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL:
		case actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL_STANDALONE:
			return {
				...state,
				currentView: viewTypes.FLOCABULARY_CREATION,
			}
		case actionTypes.DESMOS_INITIALIZE_CREATION_TOOL:
		case actionTypes.DESMOS_INITIALIZE_CREATION_TOOL_STANDALONE:
			return {
				...state,
				currentView: viewTypes.DESMOS_CREATION,
			}
		case actionTypes.GAME_INITIALIZE_CREATION_TOOL:
			return {
				...state,
				currentView: viewTypes.TIME_TO_CLIMB_CREATION,
			}
		case actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.FLIPGRID_CREATION,
			}
		case actionTypes.MAIN_SIDEBAR_CONNECTOR_INITIALIZE:
			return {
				...state,
				platform: platformTypes.EXTERNAL,
				currentView: viewTypes.REPORTS,
			}
		case actionTypes.STORE_LOCKED_CONTENT_INITIALIZE_ROUTE:
			return {
				...state,
				currentView: viewTypes.STORE_LOCKED_CONTENT,
			}
		case actionTypes.ONBOARDING_ACTIVITY_CREATE_INITIALIZE:
		case actionTypes.ONBOARDING_ACTIVITY_EXPLAINER_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.ONBOARDING_ACTIVITY,
				isActivityOnboardingSession: true,
			}
		case actionTypes.QUICK_LAUNCH_OEQ_INITIALIZE_CREATION_TOOL:
			return {
				...state,
				currentView: viewTypes.QUICK_LAUNCH_OEQ_ACTIVITY_CREATION,
			}
		case actionTypes.QUICK_LAUNCH_DRAW_IT_INITIALIZE_CREATION_TOOL:
			return {
				...state,
				currentView: viewTypes.QUICK_LAUNCH_DRAW_IT_ACTIVITY_CREATION,
			}
		case actionTypes.QUICK_LAUNCH_TIMER_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.QUICK_LAUNCH_TIMER,
			}
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.INTERACTIVE_VIDEO_CREATION_OEQ,
			}
		case actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.INTERACTIVE_VIDEO_CREATION_MCQ,
			}
		case actionTypes.VIDEO_INITIALIZE_PICKER_ROUTE:
		case actionTypes.VIDEO_INITIALIZE_EDIT_ROUTE:
		case actionTypes.VIDEO_INITIALIZE_CREATION_TOOL_BASE:
			return {
				...state,
				currentView: viewTypes.VIDEO_CREATE,
			}
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_PICKER_ROUTE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_EDIT_ROUTE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_BASE:
			return {
				...state,
				currentView: viewTypes.VIDEO_STANDALONE_CREATE,
			}
		case actionTypes.INTERACTIVE_VIDEO_SESSION_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.INTERACTIVE_VIDEO_SESSION,
			}
		case actionTypes.INTERACTIVE_VIDEO_PREVIEW_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.INTERACTIVE_VIDEO_PREVIEW,
			}
		case actionTypes.VIDEO_CREATION_OEQ_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.VIDEO_CREATION_OEQ,
			}
		case actionTypes.VIDEO_CREATION_MCQ_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.VIDEO_CREATION_MCQ,
			}
		case actionTypes.VIDEO_STANDALONE_OEQ_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.VIDEO_STANDALONE_CREATION_OEQ,
			}
		case actionTypes.VIDEO_STANDALONE_MCQ_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.VIDEO_STANDALONE_CREATION_MCQ,
			}
		case actionTypes.SESSION_PREVIEW_INITIALIZE:
			return {
				...state,
				currentView: viewTypes.SESSION_PREVIEW,
			}
		default:
			return state
	}
}

export default uiReducer
